// トリプラ（公式サイト）経由のOTA予約は、PMS上「公式」として表示する。
// 予約データ上は引き続きOTA予約（bookingTypeId: 8, otaCode: E91）であり、表示のみの置き換え。
export const TRIPLA_OTA_CODE = 'E91'
const OTA_BOOKING_TYPE_ID = 8

export const TRIPLA_OFFICIAL_LABEL = '公式（トリプラ）'
export const TRIPLA_OFFICIAL_SHORT_LABEL = '公式'

export const TRIPLA_FEE_SUBJECT = 'トリプラ宿泊'
export const TRIPLA_FEE_DISPLAY_NAME = '公式サイト宿泊'
export const TRIPLA_FEE_SELECT_NAME = '公式サイト宿泊（トリプラ）'

export function isTriplaOtaCode (otaCode) {
  return otaCode === TRIPLA_OTA_CODE
}

// OTA予約グループにスタッフが追加した非OTA予約は対象外とするため、予約タイプも確認する
export function isTriplaBooking (booking) {
  if (!booking || !booking.bookingGroup) return false
  const bookingTypeId = booking.bookingTypeId || (booking.bookingType && booking.bookingType.id)
  return Number(bookingTypeId) === OTA_BOOKING_TYPE_ID && isTriplaOtaCode(booking.bookingGroup.otaCode)
}

// 明細行・予約サマリ等の科目表示名（保存値は変更しない）
export function chargeSubjectDisplayName (subject) {
  return subject === TRIPLA_FEE_SUBJECT ? TRIPLA_FEE_DISPLAY_NAME : subject
}

// 明細の科目選択肢の表示名（スタッフ運用上トリプラを残す）
export function chargeSubjectSelectName (subject) {
  return subject === TRIPLA_FEE_SUBJECT ? TRIPLA_FEE_SELECT_NAME : subject
}
